import React from 'react'

import { Footer } from '@leshen/ui'

// Gatsby integration of @leshen/ui/Link
import Link from './Link'
import { useMapi } from '../context/MapiProvider'

const LeshenFooter = ({ ...props }) => {
  const { requestId } = useMapi()

  return <Footer CustomLink={Link} {...props} requestId={requestId} />
}

export default LeshenFooter
